import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { AttendanceMutator } from '@/lib/entity/attendance'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'
import { formatDate } from '@/lib/dateFormatUtil'

type AttendanceSchema = AttendanceMutator['merged']

export const AttendanceConverter: Converter<AttendanceSchema> = {
  icon: () => i18next.t('stages.icon.attendance'),
  title: () => i18next.t('stages.table.attendance'),
  subTitle: async (merged) =>
    formatDate(merged.month!, 'yyyy年MM月') || i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.attendance.${column}`)
    return match(column)
      .with('month', () => asModifiedField(label, modified.month))
      .with('clocks', () => {
        // const value = modified.clocks
        const value: string[] = []
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(modified.clocks!).forEach(([date, clock]) => {
          value.push(formatDate(date, 'MM月dd日'))
        })
        return asModifiedField(label, value.sort())
      })
      .with('id', 'user_id', () => undefined)
      .exhaustive()
  }
}
